// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const EXTERNAL_LAYER_SERVICE_TYPE_TO_PERSISTENCE_KEY = {
  ARCGIS_MAP: 'ArcGisMap',
  ARCGIS_IMAGE: 'ArcGisImage',
  WMS: 'WMS',
  WMTS: 'WMTS',
  VECTOR_TILE: 'VectorTile'
} as const;

/** @see net/disy/cadenza/workbook/model/ExternalLayerServiceType.java */
export type ExternalLayerServiceType = keyof typeof EXTERNAL_LAYER_SERVICE_TYPE_TO_PERSISTENCE_KEY;

export const ExternalLayerServiceType = {
  values: Object.keys(EXTERNAL_LAYER_SERVICE_TYPE_TO_PERSISTENCE_KEY) as readonly ExternalLayerServiceType[],
  toPersistenceKey: (value: ExternalLayerServiceType) => EXTERNAL_LAYER_SERVICE_TYPE_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = ExternalLayerServiceType.values.find(key => EXTERNAL_LAYER_SERVICE_TYPE_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No ExternalLayerServiceType for key: ${persistenceKey}`); }
    return value;
  },
} as const;

// </GENERATED-CODE>
